<template>
  <div
    v-if="initializing"
    class="skeleton-wrapper"
  >
    <div class="skeleton-l">
      <div class="skeleton-l-1" />
      <div class="skeleton-l-2" />
      <div class="skeleton-l-2" />
      <div class="skeleton-l-2" />
    </div>
    <div class="skeleton-r" />
  </div>
  <div
    v-else
    class="order-status-panel"
  >
    <div class="panel-l">
      <div class="status-list">
        <div
          @click="frontCartStats = item.value"
          v-for="item in status"
          :key="item.value"
          :class="{ '_active': frontCartStats === item.value }"
          class="status-list-item"
        >
          {{ item.label }}
        </div>
      </div>
    </div>
    <div class="panel-r">
      <div
        v-if="checkableCartList.length > 0"
        @click="handleCheckAll"
        class="select-all"
      >
        <CartsSelect :selected="isCheckedAll" />
        <div class="text">
          Select all items
        </div>
      </div>
      <div class="separator" />
      <div
        v-if="selectedSkuCount > 0"
        @click="handleCheckedDelete"
        class="delete-items"
      >
        Delete selected items
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue'
import { useCart } from '../../hooks/useCart'
import { useOrder } from '../../hooks/useOrder'
import CartsSelect from '../../components/CartsSelect.vue'

const { frontCartStats, initializing, isCheckedAll, cartList, handleCheckAll, handleCheckedDelete } = useCart()

const { selectedSkuCount } = useOrder()

const status = ref([
  { label: 'All', value: null },
  { label: 'Available', value: '2' },
  { label: 'Processing', value: '0' },
  { label: 'Unavailable', value: '1' }
])

const checkableCartList = computed(() => {
  return cartList.value.filter((item) => !item.disabled)
})
</script>

<style lang='less' scoped>
.order-status-panel {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 16px;

  .panel-l {
    .status-list {
      display: flex;
      gap: 12px;
      .status-list-item {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 40px;
        padding: 0 20px;
        border-radius: 20px;
        background-color: #F8F8F8;
        color: #5c5c5c;
        font-size: 12px;
        font-family: mon-600;
        cursor: pointer;
        &:hover {
          background-color: rgba(0, 0, 0, .08);
        }
        &._active {
          background-color: #232323;
          color: white;
        }
      }
    }
  }

  .panel-r {
    display: flex;
    align-items: center;
    .select-all {
      display: flex;
      align-items: center;
      gap: 4px;
      cursor: pointer;

      &:hover {
        color: #232323;
      }
      .text {
        color: #232323;
        font-size: 12px;
        font-family: mon-500;
      }
    }
    .separator {
      height: 12px;
      width: 1px;
      background-color: #ebf1f5;
      margin: 0 8px;
    }
    .delete-items {
      color: #5c5c5c;
      font-size: 12px;
      font-family: mon-500;
      cursor: pointer;
      &:hover {
        color: var(--link-hover-color);
        text-decoration: underline;
      }
    }
  }
}

.skeleton-wrapper {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 16px;
  .skeleton-l {
    display: flex;
    gap: 12px;
    .skeleton-l-1, .skeleton-l-2 {
      height: 40px;
      border-radius: 20px;
      animation: skeleton 1.3s cubic-bezier(0.4,0,0.2,1) infinite;
    }

    .skeleton-l-1 {
      width: 56px;
    }
    .skeleton-l-2 {
      width: 87px;
    }
  }
  .skeleton-r {
    width: 248px;
    height: 24px;
    border-radius: 4px;
    animation: skeleton 1.3s cubic-bezier(0.4,0,0.2,1) infinite;
  }
}

@keyframes skeleton {
  0% {
    background-color: #EBEBEB;
  }
  25% {
    background-color: #F8F8F8;
  }
  80% {
    background-color: #EBEBEB;
  }
  100% {
    background-color: #EBEBEB;
  }
}
</style>
